export default {"src":"/_next/static/media/HazardHub.3367dae3.svg","height":80,"width":80};